import React, { useCallback, useMemo, useRef, useState, useLayoutEffect, useEffect } from "react";
import { Formik, Form, ErrorMessage, useField, useFormikContext } from "formik";
import * as Yup from "yup";
import styles from "./addComment.module.css";
import IMAGES from "../../../../assets/images/images";
import { FormFieldLabel as Label, FormErrorLabel as ErrorLabel } from "../../../../components/label/Labels";
import { USER_TYPE } from "../../../../utils/constants/userConstants";
import Asterisk from "../../../../components/asterisk/Asterisk";
import CommentBoxWithAttachment from "../../../../components/CommentBoxWithAttachment/commentBoxWithAttachment";
import { CUSTOMER, INTERNAL, OTHER_SERVICES } from "../../../../utils/constants/serviceConstants";
import { useParams } from "react-router-dom";
import { Loader } from "../../../../components/loader/Loader";
import { getLogo } from "../../../../utils/constants/fileTypeLogo";
import { getInitials } from "../../../../utils/utils";
import { formatDate } from "../../../../utils/arrayUtils";
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
import ActivityLog from "../activitylogs/activitylog";
import CAN from '../../../../casl/can';
import { Action, Resource } from '../../../../casl/constants';
import { ACTION_STATUS } from "../../../../utils/constants/DemandConstant";

const CommunicationHistory = ({isCommentLoading,comments,onFileDownload,...props}) => {
    const downloadFile = (file, index, onDownload) => {
    onDownload(file)
  }
  return (
    isCommentLoading ? <Loader /> :
      <>
        {comments?.length === 0 ? (
          <div className={styles.empty}>No comments have been added yet.</div>
        ) : (
          <>
            {comments.map((comment) => (
              <div className={styles.container}>
                <div className={`${styles.profileCircle} ${comment?.visibility === INTERNAL ? styles.profileint : styles.profilecust }`}>{getInitials(comment?.createdBy?.name)}</div>
                <div className={styles.content}>
                  <div className={styles.metaRow}>
                    <span className={styles.role}>{comment.createdBy?.name}</span>
                    <span className={styles.date}>{formatDate(comment.createdAt)}</span>
                    {/* <span className={styles.type}>{comment?.visibility}</span> */}
                    {comment?.isActionRequired && <span className={styles.actiontype}>Customer Action Required </span>}
                  </div>
                  <div className={`${styles.infoContainer}`}>
                    <div className={styles.commentContainer}>
                      {comment?.comment.split('\n').map(text => <div>{text}</div>)}
                    </div>
                    {comment?.files?.length > 0 ?
                      <div className={styles.attachmetCont}>
                        <div className={styles.atachmentlabel}>Attachments</div>
                        <div className={styles.attachmentCont}>
                          {comment?.files?.map((item, index) =>
                            <div className={styles.attachment} key={index} title={item?.originalFileName}>
                              <img className={styles.attachlogos} src={getLogo(item?.originalFileName)} />
                              <span className={styles.filename}>{item?.originalFileName}</span>
                              <img className={styles.attachlog} src={IMAGES.downloadlogo} onClick={() => downloadFile(item, index, onFileDownload)} />
                            </div>)}</div>
                      </div>
                      : ''}
                  </div>
                </div>
              </div>
            ))}</>)}
      </>
  );
};

export default function AddNewComment({actionStatus,isActiveDemand,activeTab,setActiveTab,...props}) {
  const [isSubmit, setIsSubmit] = useState(false);
  let { requestId } = useParams();
  const canShowCommentTab = CAN(Action.CREATE_COMMENT, Resource.DEMANDS) || CAN(Action.GET_COMMENT, Resource.DEMANDS) ||
                    CAN(Action.GET_FEASIBILITY_COMMENT, Resource.D2C_DEMANDS) ||  CAN(Action.GET_PROVISIONING_COMMENT, Resource.D2C_DEMANDS) ||
                    (actionStatus === ACTION_STATUS.FEASIBILITY_INITIATED &&  CAN(Action.CREATE_FEASIBILITY_COMMENTS, Resource.D2C_DEMANDS)) ||
                    (actionStatus === ACTION_STATUS.PROVSIONING_INITIATED && CAN(Action.CREATE_PROVISIONING_COMMENTS, Resource.D2C_DEMANDS));

  const canShowLogTab = CAN(Action.LIST_ACTIVITY, Resource.D2C_DEMANDS);

  const UserType = props.myRights.userType;

  function FieldError({ name }) {
    const [, meta] = useField(name);
    if (!meta.touched || !meta.error) return null;
    return <div className={styles.fieldError}>{meta.error}</div>;
  }

  const initialValues = {
    commentVisibility: "",
    messageType: "",
    message: "",
    files: [],
  }
  
useEffect(() => {
  if (canShowCommentTab) {
    setActiveTab("commentTab");
  } else if (canShowLogTab) {
    setActiveTab("activitylogTab");
  }
}, [canShowCommentTab, canShowLogTab]);


  const validationSchema = useMemo(() => {
    const common = {
      message: Yup.string().max(1000, "")
        .transform((v) => (typeof v === "string" ? v.trim() : v))
        .test(
          "message-or-files",
          "To continue, please enter a message or attach at least one file.",
          function (value) {
            const { files } = this.parent;
            const hasText = !!value && value.length > 0;
            const hasFiles = Array.isArray(files) ? files.length > 0 : Boolean(files);
            return hasText || hasFiles;
          }
        ),
      files: Yup.array().nullable(),
    };
    const isInternal = UserType === USER_TYPE.INTERNAL;
    if (isInternal) {
      return Yup.object({
        commentVisibility: Yup.string()
          .transform((v) => (typeof v === "string" ? v.toLowerCase().trim() : v))
          .oneOf([INTERNAL, CUSTOMER])
          .required("Please select the applicable option as per the description below: Internal or Customer."),

        messageType: Yup.string().when("commentVisibility", {
          is: CUSTOMER,
          then: (s) => s.oneOf(["general", "need_more_info"]).required("Select the appropriate message type: General or Need More Information."),
          otherwise: (s) => s.strip(),
        }),
        ...common,
      });
    }
    return Yup.object({
      commentVisibility: Yup.mixed().strip(),
      messageType: Yup.mixed().strip(),
      ...common,
    });
  }, [UserType]);

  useEffect(() => {
    const next = null;
    props.getDemandComments(requestId, next);
    props.getActivityLog(requestId);
  }, [])

  return (
    <div>
      <div className={styles.card}>
        <div className={styles.tabsRow}>
          {canShowCommentTab && (
          <button
            type="button"
            onClick={() => setActiveTab("commentTab")}
            className={`${styles.tab} ${activeTab === "commentTab" ? styles.tabActive : ""}`}
          >
            Comments
          </button>)}
           {canShowLogTab && (
          <button
            type="button"
            onClick={() => {setActiveTab("activitylogTab") 
                            props.getActivityLog(requestId)
                          }}
            className={`${styles.tab} ${activeTab === "activitylogTab" ? styles.tabActive : ""}`}
          >
            Activity log
          </button>)}
        </div>
        <div className={styles.content}>
          {activeTab === "commentTab" ? (<>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              validateOnMount={true}
              onSubmit={(values, { resetForm }) => {
                setIsSubmit(true);
                const obj = {}
                obj.serviceType = OTHER_SERVICES;
                obj.comment = values.message;
                obj.files = values.files;
                obj.visibility = UserType !== USER_TYPE.CUSTOMER && values.commentVisibility === INTERNAL ? INTERNAL : CUSTOMER;
                obj.isActionRequired = values.messageType === "need_more_info" ? true : false;
                props.addComment(obj, requestId).then((result) => {
                  if (result.status) {
                    props.openAlertPopup({
                      message: "Comment added successfully!",
                      image: IMAGES.success
                    });
                    setIsSubmit(false);
                    resetForm();
                    let next = null;
                    props.getDemandComments(requestId, next);
                  } else {
                    let error_msg = result?.error?.message ?? "An error occurred while processing your request. Please try again later.";
                    props.openAlertPopup({
                      message: error_msg,
                      image: IMAGES.error
                    });
                    setIsSubmit(false);
                  }
                })
                  .catch((error) => {
                    props.openAlertPopup({
                      message: "An error occurred while processing your request. Please try again later.",
                      image: IMAGES.error
                    });
                    setIsSubmit(false);
                  });
              }}
            >
              {({ values, setFieldValue,setFieldTouched, isSubmitting, isValid, dirty }) => {
                const isCustomer = values.commentVisibility === CUSTOMER;
                const hasMessage = Boolean(values.message?.trim());
                const hasFiles = Array.isArray(values.files) && values.files.length > 0;
                const hasContent = hasMessage || hasFiles;
                const visibility = UserType !== USER_TYPE.INTERNAL || Boolean(values.commentVisibility);
                const messageType = UserType !== USER_TYPE.INTERNAL || values.commentVisibility !== CUSTOMER || Boolean(values.messageType);
                const sendDisabled = !(hasContent && visibility && messageType);
                return (
                  isActiveDemand &&
                  (
                    CAN(Action.CREATE_COMMENT, Resource.DEMANDS) ||
                    actionStatus == ACTION_STATUS.FEASIBILITY_INITIATED && CAN(Action.CREATE_FEASIBILITY_COMMENTS, Resource.D2C_DEMANDS) ||
                    actionStatus == ACTION_STATUS.PROVSIONING_INITIATED && CAN(Action.CREATE_PROVISIONING_COMMENTS, Resource.D2C_DEMANDS)
                  ) &&(
                  <Form>
                    {UserType === USER_TYPE.INTERNAL &&
                      <div className={styles.section}>
                        <div className={styles.segment}>
                          <button
                            type="button"
                            aria-pressed={values.commentVisibility === INTERNAL}
                            onClick={() => {
                              setFieldValue("commentVisibility", INTERNAL)
                              setFieldValue("messageType", "")
                              setFieldTouched("messageType", false, false);
                              setFieldTouched("commentVisibility", false, false);
                            }}
                            className={`${styles.segmentBtn} ${values.commentVisibility === INTERNAL
                              ? styles.segmentBtnOnint : styles.segmentBtnOff}`}   >
                            Internal
                          </button>
                          <button
                            type="button"
                            aria-pressed={values.commentVisibility === CUSTOMER}
                            onClick={() => setFieldValue("commentVisibility", CUSTOMER)}
                            className={`${styles.segmentBtn} ${values.commentVisibility === CUSTOMER
                              ? styles.segmentBtnOncus : styles.segmentBtnOff}`} >
                            Customer
                          </button>
                        </div>
                        <FieldError name="commentVisibility" />
                      </div>
                    }
                     <div className={styles.sectionWrapper}>
                        {UserType === USER_TYPE.INTERNAL &&
                          <div>
                            {isCustomer && (
                              <div className={styles.section}>
                                <div className={styles.segment}>
                                  <button
                                    type="button"
                                    aria-pressed={values.messageType === "general"}
                                    onClick={() => setFieldValue("messageType", "general")}
                                    className={`${styles.segmentBtn} ${values.messageType === "general"
                                      ? styles.segmentBtnOn : styles.segmentBtnOff}`}  >
                                    General
                                  </button>
                                  <button
                                    type="button"
                                    aria-pressed={values.messageType === "need_more_info"}
                                    onClick={() => setFieldValue("messageType", "need_more_info")}
                                    className={`${styles.segmentBtn} ${values.messageType === "need_more_info"
                                      ? styles.segmentBtnOn : styles.segmentBtnOff}`} >
                                    Need more info
                                  </button>
                                </div>
                                <FieldError name="messageType" />
                              </div>
                            )}
                          </div>}
                      </div>
                    <div className={styles.infoWrapper}>
                      {/* <div ><div className={styles.infodata}>{`${values?.commentVisibility === INTERNAL ? "internal" : values?.commentVisibility === CUSTOMER && !values.messageType ? "Customer" : values.messageType === "general" ? "general" : values.messageType === "need_more_info" ? "Need More Info" : "Lorem Ipsum is simply dummy text"}`}</div></div> */}
                         <div>
                          <div className={styles.infodata}>
                            {UserType == USER_TYPE.INTERNAL ? (
                              <div>
                                <div>
                                  Use this section to communicate queries,
                                  clarifications, or share additional
                                  information related to this demand.
                                </div>
                                <div>
                                  Select <b>Internal</b> to post messages
                                  intended for internal teams only. These
                                  comments are visible exclusively to internal
                                  users and are not shared with the customer.
                                </div>
                                <div>
                                  Select <b>Customer</b> to communicate directly
                                  with the customer. Messages posted here are
                                  visible to the customer and may be used to
                                  request clarification or provide updates.
                                </div>
                                <div>
                                  For general updates, select <b>General</b>,
                                  For clarification requests, select{" "}
                                  <b>Need More Information</b> .
                                </div>
                                <div>
                                  <b>Note:</b> All comments are logged for
                                  reference.
                                </div>
                              </div>
                            ) : (
                              <div>
                                <div>
                                  You may use this <b>Comments</b> section to
                                  follow up or share any additional information
                                  related to this demand. All received and
                                  submitted comments to date are also displayed
                                  below.
                                </div>
                              </div>
                            )}
                          </div>                        </div>
                    </div>
                    <CommentBoxWithAttachment
                      isSubmit={isSubmit}
                      sendDisabled={sendDisabled}
                    />
                  </Form>)
                );
              }}
            </Formik>
            <div className={styles.history}>
              <CommunicationHistory comments={props.demandComments} isCommentLoading={props?.isCommentLoading} onFileDownload={props.onFileDownload} />
            </div></>
          ) : (
            <ActivityLog activitylogs={props?.activitylogs} />
          )}
        </div>
      </div>
    </div>
  );
}